import { BaseEntity } from "@bndes/bndes-ux4/bndes-angular-utils";
import { BaseModel } from './base-model.model';

//DTO de estilos do menu lateral
export class TipoEstiloMenuDTO {
  public codigo: string;
	public nome: string;
}

export class LoteModalidadeGarantia {
  public modalidades: ModalidadeGarantia[];
  public mapaRoles: any;
  public mapaFeaturesPassiveisRetificacao: any;
  public mapaFeaturesPassiveisAditivo: any;
}

export class ModalidadeGarantia extends BaseModel {
  public sigla: string;
	public nome: string;
	public descricao: string;
	public textoTermosContratacao: string;
	public outrasGarantiasPermitidas: Array<string>; // list<string> tirar duvida
	public roleAssociada: string;
  public nomeValorCredito: string;
	public codigoCoordenacaoFichaCobranca: string;
  public codigoModalidadeFichaCobranca: string;
	public codigoFonteRecursos: string;
	public codigoTipoContratoHonra: string;
	public cnpjResponsavelFundo: string;
	public numeroContaContrapartidaPagamentoHonra: string;
	public numeroContaContrapartidaRecebimentoEcg: string;
	public numeroContaContrapartidaRecebimentoRecuperacaoCredito: string;
  public numeroContaRecursosCoberturaGarantia: string;
	public numeroDecisaoDiretoriaCriacaoFundo: number; // inteiro - botar mask
	public dataResolucaoDiretoriaCriacaoFundo: Date;
	public dataLimiteUltimaAmortizacao: Date;
	public siglasModalidadesValidacaoInadimplenciaTecnica: Array<string>; // list string
	public siglasModalidadesValidacaoInadimplenciaFinanceira: Array<string>; // list string
  public siglasModalidadesValidacaoInadimplenciaBeneficiario: Array<string>; // list string
	public realizaValidacaoInadimplenciaFinanceiraNoFgiTradicional: boolean;
  public realizaValidacaoInadimplenciaBeneficiarioNoFgiTradicional: boolean;
	public codigoEventoIpd: number;
	public aceitaOperacaoCreditoLivre: boolean;
  public aceitaOperacaoRepasseSistema15: boolean;
  public aceitaOperacaoRepasseSistema89: boolean;
	public aceitaModalidadeGiro: boolean;
	public aceitaModalidadeInvestimento: boolean;
  public aceitaBeneficiarioPessoaFisicaCreditoLivre: boolean;
  public aceitaBeneficiarioPessoaFisicaRepasse: boolean;
  public aceitaPatrimonioLiquido: boolean;
  public aceitaHabilitacaoAlternativa: boolean;
  public usaLimiteAporte: boolean;
  public utilizaLimiteRiscoCredito: boolean;
  public utilizaCnaesGrandesEmpresas: boolean;
  public utilizaEmpresasBloqueadas: boolean;
  public prazoMaximoEnvioLiberacaoOperacoesGiroEmDias: number;
	public aceitaUtilizacaoApiExternaFg2: boolean;
	public utilizaDadosScrNaValidacaoDeSolicitacaoHonra: boolean;
	public realizaCalculoTaxasEquivalentes: boolean;
  public utilizaRemuneracaoValidacaoLimiteFundo: boolean;
  public utilizaAtualizacaoInformacaoAcompanhamentoProcessual: boolean;
  public utilizaAtualizacaoInformacaoClassificacaoRisco: boolean;
  public utilizaRelatorioPENG: boolean;
  public utilizaRelatorioSaldoGarantido: boolean;
  public cobrancaEcgEstaAtiva: boolean;
  public necessarioTratarValorTotalDosRecursosDaTranche: boolean;
  public  idTipoCalculoLimiteBeneficiario: string;
  public permiteAditivoSubstituicaoBeneficiario: boolean;
  public emailAdministrador: string;
  public usuarioResponsavel: string;
  public percentuaisGarantiaPermitidos: Array<number>;
  public dataCriacao: string;
  public existeLimiteAgenteFinanceiroTranche: boolean;
  public numeroContaContabilConfrontoHonraCreditoLivre: string;
	public numeroContaContabilConfrontoHonraRepasse: string;
	public identificadorBancoEmpresaSap: string;
	public identificadorCoordenadasContaSap: string;
	public identificadorFinalidadeTedPagamentoHonraSap: string;

  public textoObservacaoLimiteTotal: string;
  public textoTermosEnvioDevolucaoHonra: string;
  public mensagemAvisoSCR: string;
  public estiloMenu: string;

  public utilizaIndicadorEscoParaProgramasAceitos: boolean;

  public configuracaoEcg: ConfiguracaoEcg;
	public configuracaoEventosScc: ConfiguracaoEventosScc;
	public faixasDeContratos: FaixaContratos[];
  public historicos: HistoricoModalidadeGarantia[];
  public idTipoConglomerado: string;
  public aceitaSubscricaoCota: boolean;
  public utilizaRemuneracaoCoberturaMaxima: boolean;
  public textoTermoRemuneracaoCoberturaMaxima: string;
  public textoTermoEmpresasBloqueadas: string;
  public aceitaAlteracaoPercentualGarantido: boolean;
  public utilizaTaxaAtualizacaoGarantia: boolean;
  public utilizaLeilao: boolean;
  public realizaUploadDocsAcompanhamento: boolean;
  public textoTermoInformeLiquidacao: string;
  public textoTermoRenunciaLimiteAdicional: string;
  public utilizaPagamentoDeEcgPorTerceiros: boolean;
  public identificadorFinalidadeTedPagamentoEcgTerceirosSap: string;
}

export class ConfiguracaoEcg extends BaseModel {
  public valorAliquotaFixaEcg: number; // nulo se a alíquota nao for fixa
	public codigoTipoContratoEcgCreditoLivre: string;
	public codigoTipoContratoEcgRepasse: string; // só é relevante se houver ECG cobrado via boleto (ate o momento, nunca tivemos isso)
	public ideUnidadeMonetariaRelatorioRepasseEcgParaOperacoesRepasse: number;
	public ideTipoEcgRepasseSomadoAoSaldo: string;
	public ideTipoEcgRepasseIncluidoNoSaldo: string;
	public ideTipoEcgRepasseBoletoRepassadoAoCliente: string;
	public ideTipoEcgRepassePagoPorTerceiros: string;
	public alteraValorEcgEmAditivo: boolean;
}

export class ConfiguracaoEventosScc extends BaseModel {
  // ECG
  public codigoEventoRetencaoECGRepasse: string;
  public codigoEventoEstornoRetencaoECGRepasse: string;
  public codigoEventoECGCreditoLivreCobrado: string;
  public codigoEventoEstornoECGCreditoLivreCobrado: string;
  public codigoEventoECGRepasseCobrado: string;
  public codigoEventoEstornoECGRepasseCobrado: string;

  // Honra
  public codigoEventoHonraCreditoLivre: string;
  public codigoEventoHonraLiquidacaoSaldoVincendo: string;
  public codigoEventoHonraPagamentoParcelasVencidas: string;
  public codigoEventoHonraLiquidacaoSaldoVincendoNoContratoOriginal: string;
  public codigoEventoEstornoHonraRepasse: string;

  // ---- Recuperacao de Credito ----- //
  public codigoEventoRecuperacaoCreditoHistoricoRepasse: string;
  public codigoEventoRecuperacaoCreditoHistoricoCreditoLivre: string;
  public codigoEventoRecuperacaoCreditoAtualizacao: string;
  public codigoEventoRecuperacaoCreditoMulta: string;
  public codigoEventoRecuperacaoCreditoRemuneracao: string;
  public codigoEventoEstornoRecuperacaoCreditoHistoricoRepasse: string;
  public codigoEventoEstornoRecuperacaoCreditoHistoricoCreditoLivre: string;
  public codigoEventoEstornoRecuperacaoCreditoAtualizacao: string;
  public codigoEventoEstornoRecuperacaoCreditoRemuneracao: string;

  // ---- Leilão ---- //
  public codigoEventoLeilaoRepasse: string;
  public codigoEventoEstornoLeilaoRepasse: string;
  public codigoEventoRemuneracaoLeilao: string;
  public codigoEventoEstornoRemuneracaoLeilao: string;
  public codigoEventoLeilaoCreditoLivre: string;
  public codigoEventoEstornoLeilaoCreditoLivre: string;
  public codigoEventoBaixaLeilaoCreditoLivre: string;
  public codigoEventoBaixaLeilaoRepasse: string;
  public codigoEventoEstornoBaixaLeilaoCreditoLivre: string;
  public codigoEventoEstornoBaixaLeilaoRepasse: string;

  // ---- Reversao de Honra ----- //

  public codigoEventoReversaoHonraHistoricoRepasse: string;
  public codigoEventoReversaoHonraHistoricoCreditoLivre: string;
  public codigoEventoReversaoHonraAtualizacao: string;
  public codigoEventoReversaoHonraMulta: string;
  public codigoEventoReversaoHonraRemuneracao: string;
  public codigoEventoEstornoReversaoHonraHistoricoRepasse: string;
  public codigoEventoEstornoReversaoHonraHistoricoCreditoLivre: string;
  public codigoEventoEstornoReversaoHonraAtualizacao: string;
  public codigoEventoEstornoReversaoHonraRemuneracao: string;
}

export class FaixaContratos {
  public codigoTipoOperacao: string;
	public codigoTipoContratoScc: string;
	public inicioFaixaContratos: number;
	public fimFaixaContratos: number;
}

export class HistoricoModalidadeGarantia extends BaseEntity {

  public id: number;
  public dataCriacao: Date;
  public sigla: string;
  public nome: string;
  public descricao: string;
  public textoTermosContratacao: string;
  public textoTermosEnvioDevolucaoHonra: string;
  public outrasGarantiasPermitidas: Array<string>; //aba outras garantias
  public roleAssociada: string;
  public nomeValorCredito: string;
  public codigoCoordenacaoFichaCobranca: string; //aba cobranca
  public codigoModalidadeFichaCobranca: string; // aba cobranca
  public codigoFonteRecursos: string; // aba cobranca
  public codigoTipoContratoHonra: string; // aba cobranca
  public cnpjResponsavelFundo: string;
  public numeroContaContrapartidaPagamentoHonra: string;
  public numeroContaRecursosCoberturaGarantia: string;
  public numeroDecisaoDiretoriaCriacaoFundo: number;
  public dataResolucaoDiretoriaCriacaoFundo: Date;
  public dataLimiteUltimaAmortizacao: Date;
  public dataLimiteSolicitacaoHonra: Date;
  public siglasModalidadesValidacaoInadimplenciaTecnica: Array<string>; // aba validacao inadimplencia
  public siglasModalidadesValidacaoInadimplenciaFinanceira: Array<string>; // aba validacao inadimplencia
  public realizaValidacaoInadimplenciaFinanceiraNoFgiTradicional: boolean; // aba validacao inadimplencia
  public siglasModalidadesValidacaoInadimplenciaBeneficiario: Array<string>; // aba validacao inadimplencia
  public realizaValidacaoInadimplenciaBeneficiarioNoFgiTradicional: boolean; // aba validacao inadimplencia
  public permiteAditivoSubstituicaoBeneficiario: boolean;
  public codigoEventoIpd: number;
  public aceitaOperacaoCreditoLivre: boolean;
  public aceitaOperacaoRepasseSistema15: boolean;
  public aceitaOperacaoRepasseSistema89: boolean;
  public aceitaModalidadeGiro: boolean;
  public aceitaModalidadeInvestimento: boolean;
  public aceitaBeneficiarioPessoaFisicaCreditoLivre: boolean;
  public aceitaBeneficiarioPessoaFisicaRepasse: boolean;
  public aceitaUtilizacaoApiExternaFg2: boolean;
  public utilizaDadosScrNaValidacaoDeSolicitacaoHonra: boolean;
  public realizaCalculoTaxasEquivalentes: boolean;
  public utilizaRemuneracaoValidacaoLimiteFundo: boolean;
  public utilizaAtualizacaoInformacaoAcompanhamentoProcessual: boolean;
  public utilizaAtualizacaoInformacaoClassificacaoRisco: boolean;
  public utilizaRelatorioPENG: boolean;
  public utilizaRelatorioSaldoGarantido: boolean;
  public necessarioTratarValorTotalDosRecursosDaTranche: boolean;
  public idTipoCalculoLimiteBeneficiario: string;
  public prazoMaximoEnvioLiberacaoOperacoesGiroEmDias: number;
  public emailAdministrador: string;
  public textoObservacaoLimiteTotal: string;
  public mensagemAvisoSCR: string;
  public usuarioResponsavel: string;
	public numeroContaContrapartidaRecebimentoEcg: string;
  public numeroContaContrapartidaRecebimentoRecuperacaoCredito: string;
}


export enum TipoOutraGarantia {
  NENHUMA = '0',
  PESSOAL_PF = '1',
  BENS_EQUIPAMENTOS = '2',
  VEICULOS = '3',
  IMOVEIS = '4',
  DIREITOS_CREDITORIOS = '5',
  PESSOAL_PJ = '6',
  DEVEDOR_SOLIDARIO = '7',
}

export enum TipoOperacao {
  REPASSE_BNDES = 'R',
  CREDITO_LIVRE = 'L'
}

export const LabelTipoOutraGarantia = new Map<string, string>([
  [TipoOutraGarantia.NENHUMA,'Nenhuma'],
  [TipoOutraGarantia.PESSOAL_PF,'Pessoal PF'],
  [TipoOutraGarantia.BENS_EQUIPAMENTOS,'Bens e Equipamentos'],
  [TipoOutraGarantia.IMOVEIS,'Imóveis'],
  [TipoOutraGarantia.DIREITOS_CREDITORIOS,'Direitos Creditórios'],
  [TipoOutraGarantia.PESSOAL_PJ,'Pessoal PJ'],
  [TipoOutraGarantia.DEVEDOR_SOLIDARIO,'Devedor Solidário'],
])

export const LabelTipoOperacao = new Map<string, string> ([
  [TipoOperacao.REPASSE_BNDES, 'Repasse BNDES'],
  [TipoOperacao.CREDITO_LIVRE, 'Crédito Livre'],
])

export const TiposOperacao = [
  {
    nome: LabelTipoOperacao.get(TipoOperacao.CREDITO_LIVRE),
    codigo: TipoOperacao.CREDITO_LIVRE
  },
  {
    nome: LabelTipoOperacao.get(TipoOperacao.REPASSE_BNDES),
    codigo: TipoOperacao.REPASSE_BNDES
  }
]


export const TIPO_CALCULO_LIMITE_BENEFICIARIO = [

  {
    nome: 'Crédito',
    numero: '1'

  },
  {
    nome: 'Comprometimento',
    numero: '2'
  },
  {
    nome: 'Valor Garantido',
    numero: '3'
  }
]

export const COM_PORCENTAGEM_AUTOMATICO = '1';
export const COM_PORCENTAGEM_MANUAL = '2';

export const TIPO_CONGLOMERADO = [
  {
    nome: 'Conglomerado c/ % automático Subscrição',
    numero: COM_PORCENTAGEM_AUTOMATICO,
  },
  {
    nome: 'Conglomerado c/ % manual',
    numero: COM_PORCENTAGEM_MANUAL,
  },
];

export const MODALIDADE_GARANTIA_FGBS = 'FGBS';
export const MODALIDADE_GARANTIA_FGT = 'FGT';
export const MODALIDADE_GARANTIA_PEAC_CS_RS = 'PEAC-CS-RS';
export const MODALIDADE_GARANTIA_PEAC_BS_EX = 'PEAC-BS-EX';

export const MODALIDADES_ACEITAS_ABA_OUTRAS_GARANTIAS = { FGT: "FGT", FGBS: "FGBS" }
